/* These exported strings reference CSS custom properties defined in src/index.css.
 * The properties are swapped at runtime via the `data-scc-theme` attribute on <body>,
 * so referencing them via sx / style still picks up the active theme. */
export const styles = {
    transition: 'all ease-out 0.3s',
    tableHoverColor: 'var(--scc-table-hover)',
    border: '1px solid var(--scc-border-color)',
    borderColor: 'var(--scc-border-color)',
    fontColor: {
        main: 'var(--scc-text-main)',
        secondary: 'var(--scc-text-secondary)',
        comment: 'var(--scc-text-comment)',
    },
    backgroundColor: {
        titleBox: 'var(--scc-titlebox-bg)',
        contentBox: 'var(--scc-contentbox-bg)',
    },
    editColor: 'var(--scc-edit-color)',
    deleteColor: 'var(--scc-delete-color)',
    replyColor: 'var(--scc-reply-color)',
    buttonColor: {
        main: 'var(--scc-button-main)',
        secondary: 'var(--scc-button-secondary)',
        remove: 'var(--scc-button-remove)',
    },
    textHidden: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    textKeepAll: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        wordBreak: 'keep-all',
    },
};
